<style lang="less" scoped>
  .image-ratio-wrapper {
    position: relative;
    width: 100%;
    padding-bottom: calc((3 / 2) * 100%); // 2:3 ratio
  }
  .image {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  .body {
    padding: 20px 20px 14px 20px;
    &.no-side-padding {
      padding: 10px 0 14px 0;
    }
    p {
      &:not(:first-of-type) {
        margin-top: 11px;
      }
    }
    .info {
      padding-top: 10px;
    }
    .form {
      padding-top: 5px;
      p.price {
        padding-top: 4px;
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    padding: 0 20px 15px 20px;
    &.no-side-padding {
      padding: 0 0 15px 0;
    }
  }
  .click-count, .like-count {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #808080;
  }
  .highlight {
    margin-left: 4px;
    color: #ff6c00;
  }
  .like-count {
    margin-left: 8px;
  }

  .product-item-container {
    position: relative;
    .el-button {
      position: absolute;
      top: 5px;
      right: 5px;
      z-index: 1;
    }
  }
</style>

<style lang="less">
  .form.product {
    .no-guid-input {
      .el-input__inner {
        border: 0 !important;
        font-size: 13px;
        background: transparent !important;
        border-bottom: 1px solid #ff6c00 !important;
        border-radius: 0;
        box-sizing: inherit;
        height: 25px !important;
        line-height: 30px;
        padding: 0;
      }
      &.el-cascader {
        width: 100%;
        line-height: 24px !important;
      }
      .el-cascader__label {
        font-size: 13px;
        padding: 0;
      }
      .el-input .el-input__icon {
        line-height: 24px;
      }
    }
  }
</style>


<template lang="pug">
 .product-item-container
    el-button(
      v-if="edit === true",
      :type="buttonType",
      :loading="loading",
      icon="el-icon-edit",
      size="mini",
      circle,
      @click="handleModify"
    )
    el-button(
      v-if="del === true",
      type="danger",
      icon="el-icon-delete",
      size="mini",
      circle,
      @click="handleDelete"
    )
    .image-ratio-wrapper
      .image(:style="{ backgroundImage: `url('${imgPath}')` }")
    .body(:class="{ 'no-side-padding': noPadding }")
      .form.product(v-if="modify === true")
        el-input(v-if="modify === true", v-model="name", class="no-guid-input")
        el-cascader.product(
          v-if="modify === true",
          v-model="categoryOptions",
          class="no-guid-input",
          separator=">",
          :options="options",
        )
        p.price {{ price | displayPrice }}
      .info(v-if="modify !== true")
        p.name {{ name }}
        p.category {{ categoryDepth1 }} > {{ categoryDepth2 }}
        p.price {{ price | displayPrice }}
    .footer(:class="{ 'no-side-padding': noPadding }")
      p.click-count 클릭 #[span.highlight {{ hit }}]
      p.like-count 관심상품 #[span.highlight {{ frCount }}]
</template>

<script>
export default {
  props: {
    noPadding: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    del: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: null,
    },
    categories: {
      type: Array,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    this.prodSeq = this.product.prodSeq;
    this.name = this.product.prodName;
    this.price = this.product.dcPrice;
    this.categoryOptions[0] = this.product.prodGender;
    this.categoryOptions[1] = this.product.cateSeq;
    this.categoryDepth1 = this.gender[this.product.prodGender];
    this.categoryDepth2 = this.product.cateName;
    this.frCount = this.product.frCount;
    this.hit = this.product.appHit + this.product.mobHit + this.product.webHit;
    this.imgPath = (this.product.imgPath.indexOf('http') === 0) ? this.product.imgPath : `${this.s3ProdImgPath}${this.product.imgPath}`;

    this.options = this.categories;
  },
  filters: {
    displayPrice(value) {
      return value.toLocaleString();
    },
  },
  methods: {
    handleModify() {
      if (!this.modify) {
        // 수정
        this.visible = false;
        this.modify = true;
        this.buttonType = 'primary';
      } else {
        // 저장
        this.loading = true;
        this.$emit('modify', this.prodSeq, this.name, this.categoryOptions);

        const index = this.options.map(e => e.value).indexOf(this.categoryOptions[0]);
        const children = this.options[index].children.map(e => e.value).indexOf(this.categoryOptions[1]);

        this.categoryDepth1 = this.options[index].label;
        this.categoryDepth2 = this.options[index].children[children].label;

        setTimeout(() => {
          this.loading = false;
          this.modify = false;
          this.buttonType = 'warning';
        }, 1000);
      }
    },
    handleDelete() {
      this.$emit('delete', this.product, this.index);
    },
  },
  data() {
    return {
      gender: { F: 'WOMEN', M: 'MEN', A: 'UNISEX' },
      loading: false,
      buttonType: 'warning',
      modify: false,
      prodSeq: 0,
      imgPath: '',
      name: null,
      categoryOptions: ['', ''],
      categoryDepth1: '',
      categoryDepth2: '',
      options: null,
      price: 0,
      hit: 0,
      frCount: 0,
    };
  },
};
</script>
